module.exports = __webpack_public_path__ + "img/flight-deck-gal-4.090a097e.jpg";